import React, {useState, useRef, useEffect} from 'react';
import {gql} from 'apollo-boost';
import axios from 'axios';
import {Grid, Box, ButtonBase} from '@material-ui/core';
import styled from 'styled-components';
import {isWidthUp} from '@material-ui/core/withWidth';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import {ReactSVG} from 'react-svg';
import {sortBy, uniqBy, findIndex, get} from 'lodash';
import Router from 'next/router';
import {makeStyles} from '@material-ui/core/styles';
import qs from 'qs';
import produce from 'immer';
import topoPng from '../../../src/assets/topo-grey.png';

import {theme} from '../../../src/themes/default-theme';
import Text from '../../../src/components/typography';
import withWidth from '../../../src/components/hoc/withWidth';
import jaycoClient from '../../../src/graphql/stockClient';


import StockFilter from '../../../src/containers/ForSaleFilter';
import filter from '../../../src/assets/icons/filter-blue.svg';

import close from '../../../src/assets/icons/close-grey-thin.svg';

import Cta from '../../../src/components/ui/Cta';
import Icon from '../../../src/components/ui/Icon';
import StockCard from '../../../src/components/navigation/StockCard';
import Dropdown from '../../../src/components/ui/Dropdown';
import Pagination from '../../../src/components/navigation/Pagination';
import toPrice from '../../../src/util/toPrice';
import StockItem from '../../../src/containers/StockItem';
import Loader from '../../../src/components/ui/Loader';
import getUrlParams from '../../../src/util/getUrlParams'
import dlPush from '../../../src/util/dlPush';
import repaymentCalc from '../../../src/util/repaymentCalc';
import Modal from '../../../src/components/ui/Modal';
import GetLocation from '../../../src/containers/GetLocation';
import latestTimestamp from '../../../src/util/latestPostcodeTimestamp';
import getClosestCoordinate from '../../../src/util/getClosestCoodinate';
import ContentBuilder from '../../../src/containers/ContentBuilder';
import Breadcrumbs from '../../../src/components/navigation/NewBreadcrumbs';
import FilterItem from '../../components/filters/FilterItem';
import Link from 'next/link';
import getStateName from '../../util/getStateName';


const Container = styled.div `
  padding-bottom: 30px;
  overflow: hidden;
  position: relative;

  ${props => props.greyBg && `
      background-color: ${theme.palette.lightGrey};
  `}


  ${props => props.pt === 0 && `
    padding-top: 0;
    padding-bottom: 0;
  `}

  ${theme.breakpoints.up('md')} {
    padding: 0;
    padding-bottom: 60px;

    ${props => props.pt === 0 && `
      padding-top: 0px;
      padding-bottom: 0;
    `
  }

  ${theme.breakpoints.up('lg')} {
    padding-bottom: 100px;
    ${props => props.pt === 0 && `
      padding-top: 0px;
      padding-bottom: 0;
    `
	}

`

const TitleContainer = styled.div`
  margin-bottom: 18px;

  h1 {
    text-align: center;
  }

  ${theme.breakpoints.up('lg')} {

    h1 {
      text-align: left;
    }
  }
`

const GreyWrapper = styled.div`
  position: relative;
`

const GreyBg = styled.div`

`

const FilterContainer = styled.div`
  padding-bottom: 70px;
`

const CloseContainer = styled.div`

  text-align: right;
  padding: 7px;
  width: 100%;
  background-color: ${theme.palette.white};
  position: fixed;
  z-index: 99;

`

const Filters = styled.div`
  overflow-x: hidden;
  padding-top: 60px;
  padding-bottom: 30px;
  max-width: 480px;
  margin: 0 auto;

  ${theme.breakpoints.up('lg')} {
    padding-top: 30px;
  }
`

const FilterBtn = styled(props => {
  return <Cta {...props} />
})`
  display: block;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1.71px;
  line-height: 24px;
  max-width: 330px;
  width: 100%;
  margin: 30px auto;

  svg {
    width: 17px;
    height: 13px;
    display: block;
    position: absolute;
    top: 14px;
    left: 50%;
    transform: translateX(-65px);
  }

  span {
    padding-left: 34px;
  }
`
const CaravanCardWrapper = styled(Box)`
  height: 100%;
`

const CaravanCardContainer = styled.div`
  margin: 0 auto 20px;
  height: 100%;
`

const Display = styled.div`
  margin-top: 5px;
  padding-bottom: 30px;
  border-bottom: 1px solid #D6D6D6;

  ${theme.breakpoints.up('md')} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 35px
  }
`

const DisplayItems = styled.div`
  margin-bottom: 15px;

  button,
  a {
    display: inline-block;
    margin-right: 10px;
    ${theme.breakpoints.down('sm')} {
      margin-bottom: 10px;
    }
  }
  
  a {
    color: ${theme.palette.gunmentalGrey};
  }

  ${theme.breakpoints.down('sm')} {
    text-align: center;
    * {
      text-align: center;
    }

    h6 {
      margin-bottom: 5px;
    }
  }

  ${theme.breakpoints.up('md')} {
    margin-bottom: 0
  }
  
`

const DisplayDropdown = styled.div`
  width: 100%;
  max-width: 270px;
  margin: 0 auto;

  ${theme.breakpoints.up('md')} {
    max-width: 305px;
    width: 100%;
    margin: 0;
  }
`

const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  button[disabled],
  button[disabled].MuiPaginationItem-root {
    opacity: 0.5 !important;
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;

  button {
    min-width: 45%;
  }
`

const Wrapper = styled.div`
  ${props => props.hide === 1 && `
    display: none;
  `}
`

const GetLocationContainer = styled.div`
  background-color: ${theme.palette.lightGrey};
  max-width: 366px;
  margin: 0 auto;
  padding: 20px;
  border-bottom-left-radius: 30px;

  ${theme.breakpoints.up('md')} {
    padding: 40px 50px;
    border-bottom-left-radius: 60px;
  }
`

const GetLocationError = styled.div`
  p {
    color: ${theme.palette.error.form};
  }
`

const LoaderContainer = styled.div`
  ${props => props.minHeight && `
    min-height: ${props.minHeight};
  `}
`

const BreadcrumbsContainer = styled.div`
  margin-bottom: 20px;
  position: relative;
  margin-top: 20px;

  ${props => props.margin === 1 && `
    margin-top: 30px;
  `}

  ${theme.breakpoints.down('sm')} {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`

const CustomGrid = styled(Grid)`
  ${theme.breakpoints.up('md')} {
    max-width: 1490px !important;
    padding: 0 30px !important;
  }

`

const Topo = styled.div`
    display: block;
    top: 0;
    left: 0;
    z-index: 1;
    overflow: hidden;
    background-image: url(${topoPng});
    background-position: center;
    width: 100%;
    background-size: 100% auto;
    margin-bottom: 30px;

    ${theme.breakpoints.up("md")} {
      margin-bottom: 45px;
    }

    span,
    a {
      color: #758094;
    }
`

const Locations = styled.div`
    margin-bottom: 30px;

    a {
      display: inline-block;
      text-decoration: underline;
      &:first-child {
        margin-left: 5px;
      }
      margin-right: 10px;
      text-transform: capitalize;
      color: ${theme.palette.gunmentalGrey}
    }

    > * {
        ${theme.breakpoints.down('sm')} {
          text-align: center;
        }
    }
`

const ShowingText = styled(Text)`
    ${theme.breakpoints.down('sm')} {
      text-align: center;
      margin-bottom: 20px;
    }
`

const LeftPadding = styled.div`
  ${theme.breakpoints.up('lg')} {
      padding-left: 30px;
      padding-right: 30px;
  }
`

const ForSale = (props) => {

  const customTheme = createTheme({
    overrides: {
      MuiDrawer: {
        paper: {
          width: '100%',
          backgroundColor: theme.palette.white
        }
      },
      MuiBackdrop: {
        root: {
          display: 'none',
        }
      }
    }
  });

  const useStyles = makeStyles(theme => ({
    modalOverlay: {
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
        paddingRight: 0,
      }
    },
    modalInner: {
      width: '100%',
      display: 'inline-block',
      position: 'relative',
      maxWidth: 390,

      [theme.breakpoints.up('md')]: {
        maxWidth: 520,
      }
    },
    modalClose: {
      top: '-40px',
      left: 10,
      marginBottom: '20px',
      position: 'absolute',

      [theme.breakpoints.up('md')]: {
        top: 0,
        bottom: 'auto',
        left: 'auto',
        right: 20,
        marginBottom: 0,
      }
    }
  }));
  
  const numberPerPage = 15;
  const [stockFilterData, setStockFilterData] = useState(null);
  const [apiData, setApiData] = useState(null);
  const [allStock, setAllStock] = useState([]);
  const [categoryStock, setCategoryStock] = useState([]);
  const [sortByVal, setSortByVal] = useState({value: 'low'});
  const [stockItems, setStockItems] = useState([]);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(numberPerPage);
  const [drawer, setDrawer] = useState(false);
  const [modal, openModal] = useState(false);
  const [locationError, setLocationError] = useState(null);
  const [postcodes, setPostcodes] = useState([]);
  const [dealerSuburbs, setDealerSuburbs] = useState([]);
  const activeModelParam = process.browser ? getUrlParams().model : get(props, 'router.query.model', null);
  const [activeModelId, setActiveModelId] = useState(activeModelParam);
  const [activeModel, setActiveModel] = useState(null);
  const [defaultPageTitle, setDefaultPageTitle] = useState(process.browser ? document.title : null);
  const [loading, setLoading] = useState(false);
  const [jsonLoading, setJsonLoading] = useState(true);
  const [loaderHeight, setLoaderHeight] = useState(0);
  const [regions, setRegions] = useState([]);

  const [qsSetState, setQsSetState] = useState(false);
  const [postcodeData, setPostcodeData] = useState(null);

  const rangeCategory = get(props, 'router.query.category', props.range).split('-').join(' ');

  const defaultFilters = {
    key: Date.now(),
    types: [],
    categories: [],
    locations: [],
    brands: [],
    models: []
  }
  
  const [filters, updateFilters] = useState(defaultFilters);

  useEffect(() => {
    const qsData = qs.parse(window.location.search.replace('?',''));

    if (qsData && qsData.search && (filters.brands.length > 1) && !qsSetState && allStock.length > 0) {

      const newFitlerState = produce(filters, draftState => {
        if (qsData.search.minPrice || qsData.search.maxPrice) {
          draftState.price.key = Date.now() + 1;
        }
        if (qsData.search.minPrice) {
          draftState.price.val[0] = parseInt(qsData.search.minPrice);
        }
        if (qsData.search.maxPrice) {
          draftState.price.val[1] = parseInt(qsData.search.maxPrice);
        }

      

        if (qsData.search.type && qsData.search.type !== 'all') {
          const hasType = filters.types.find(item => item.value.toLowerCase() === qsData.search.type.toLowerCase());
          draftState.types = draftState.types.map(item => {
            if (!hasType) {
              return {
                ...item
              }
            }
            if (item.value.toLowerCase() === qsData.search.type.toLowerCase()) {
              return {
                ...item,
                checked: true
              }
            } else {
              return {
                ...item,
                checked: false
              }
            }
          })
        }

      })


      handleUpdate(newFitlerState, false);
      setQsSetState(true);
    } 
    
    // else if (filters.brands.length > 1 && qsData && qsData.series && !qsSetState) {
    //   console.log('set filters... newFitlerState', qsData.series, filters);
    //   handleUpdate(filters, false);
    //   setQsSetState(true);
    // }
  }, [filters])

  const getStockFilterData = () => {


    const categories = uniqBy(allStock.filter(item => {
      return item.category
    }).map((item) => { 
      return {
        value: item.category.toLowerCase(), 
        text: item.category.toLowerCase(),
        checked: item.category.toLowerCase() === rangeCategory.toLowerCase() ? true : false
      }
    }), 'value');

    const locations = (props.state && props.region) ? [props.state, props.region] : props.state ? [props.state] : []

    let types = [];
    let brands = [];
    let models = [];
    let minPrice = 0;
    let maxPrice = 0;
    let minYear = null;
    let maxYear = null;

    const catStock = allStock.filter(stock => {
      return stock.variant && (stock.variant.toLowerCase() === rangeCategory.toLowerCase());
    })

    const stockArr = catStock.length === 0 ? allStock : catStock

    stockArr.forEach((item, index) => {

      // if item.type is not in type array
      const typeIndex = findIndex(types, {value: item.type})
      if (typeIndex === -1) {
        types.push({value: item.type, text: item.type})
      }

      // if item.brand is not in brands array
      const brandIndex = findIndex(brands, {value: item.brand})
      if (brandIndex === -1) {
        brands.push({value: item.brand, text: item.brand, models: []})
      }
      
      // if item.model is not in brands.model
      const bIndex = brandIndex === -1 ? (brands.length - 1) : brandIndex;
      const modelIndex = findIndex(models, {value: item.name});

      if (modelIndex === -1) {
        models.push({value: item.name, text: item.name, checked: true});
      }

      // price
      
      const price = parseInt(item.price);

      // if (minPrice === 0 && maxPrice === 0 && price !== 0) {
      if (index === 0) {
        minPrice = price;
        maxPrice = price;
      }

      if (price > maxPrice) {
        maxPrice = price;
      }
      // if (price < minPrice && price !== 0) {
      if (price < minPrice) {   
        minPrice = price;
      }

      // year
      const year = parseInt(item.year)
      if (!minYear || year < minYear) {
        minYear = year
      }
      if (!maxYear || year > maxYear) {
        maxYear = year
      }

      const brandModelIndex = brands[bIndex] ? findIndex(brands[bIndex].models, {value: item.name}) : null;
      if (brandModelIndex === -1) {
      // if (brandModelIndex === -1 && categories.find(cat => (cat.checked) && (cat.text.toLowerCase() === item.category.toLowerCase()))) {
        brands[bIndex].models.push({value: item.name, text: item.name});
      }
    });

    const filteredCategories = categories.filter(item => item.value.length > 0);
    const sortedCategories = sortBy(filteredCategories, 'text');

    const checkedTypes = types.map(item => {
      if (item.checked === undefined) {
        return {
          ...item,
          checked: true
        }
      }
      return item
    })

    const checkedBrands = brands.map(item => {
      if (item.checked === undefined) {
        return {
          ...item,
          checked: true
        }
      }
      return item
    })

    let allTypes = true
    checkedTypes.forEach(i => {
      if(i.checked === false) {
        allTypes = false
      }
    })

    let allCats = true
    sortedCategories.forEach(i => {
      if(i.checked === false) {
        allCats = false
      }
    })


    let allBrands = true
    brands.forEach(i => {
      if(i.checked === false) {
        allBrands = false
      }
    })

    const sortedBrands = sortBy(checkedBrands, 'text');

    const filterMaxPrice = maxPrice > 320000 ? maxPrice : 320000

    const stockFilter = {
      types: [{value: 'all', text: 'All', checked: allTypes}, ...checkedTypes],
      categories: [{value: 'all', text: 'All', checked: allCats}, ...sortedCategories],
      locations: locations,
      brands: [{value: 'all', text: 'All', checked: allBrands}, ...sortedBrands],
      models,
      price: {
        min: minPrice, 
        max: filterMaxPrice,
        val: [minPrice, filterMaxPrice],
      },
      year: {
        min: minYear, 
        max: maxYear,
        val: [minYear, maxYear],
      },
      key: Date.now()
    }

    return stockFilter;
  }

  const getYear = (date) => {
    const s = date.toString();
    return s.substr(s.length - 4);
  }

  const refactorUbsData = (data) => {
    return data.map((item, index) => {
      const images = item.images ? item.images.split(',') : [];

      const price = (item.driveAwayPrice !== undefined || item.driveAwayPrice !== null) ? item.driveAwayPrice : item.askingPrice

      return {
        ...item,
        brand: item.make || null,
        category: item.variant,
        year: getYear(item.buildDate),
        id: item.id,
        type: item.type,
        name: item.model,
        price: price ? price : 0,
        images,
        weeklyRepayment: (price && price.toString() !== '0') ? parseInt(repaymentCalc(props.rates, 52, price)) : null,
        cta: {
          text: "Find out more",
          url: `${window.location.pathname}?model=${item.id}`
        }
      }
    })

  }

  useEffect(() => {
    console.log('getStockFilterData categoryStock', {categoryStock})
    sortItems(categoryStock);
  },[categoryStock])

  const sortItems = (data) => {

    var items;

    const stock = data || stockItems

    // when sort is set to low then grab the items with price first
    const stockArr = (sortByVal && sortByVal.value && sortByVal.value === 'low') ? [
      ...sortBy(stock.filter(item => item.price && item.price > 0), ['price']),
      ...sortBy(stock.filter(item => !item.price || item.price === 0), ['price'])
    ] : stock

    if(!sortByVal) {
      items = sortBy(stock, ['name']);
    } else {
      switch(sortByVal.value) {
        case 'low':
          items = stockArr // sortBy(stock, ['price']);
          break;
        case 'high':
          items = sortBy(stock, ['price']).reverse();
          break;
        default:
          items = sortBy(stock, ['name']);
      }
    }

    // console.log('SORT:', {stockArr, items})

    setStockItems(items);
  }

  const between = (x, min, max) => {
    return x >= min && x <= max;
  }

  const handleUpdate = (filters, updateUrl) => {

    const cat = filters.categories.find(item => item.checked);

    const category = cat ? cat : {
      value: props.range,
      text: props.range,
      checked: true
    }

    const categoryParam = category && category.text && props.categories.indexOf(category.text.toLowerCase().replace(' ', '-')) === -1 ? `?category=${category.text.toLowerCase().replace(' ', '-')}` : '';

    if (updateUrl !== false) {
      // if locations.length === 0 then go to all
      if (filters.locations.length === 0) {
        const url = categoryParam.length > 0 ? 
          `/for-sale/${props.range.replace(' ', '-')}${categoryParam}` 
          : `/for-sale/${category.text.replace(' ', '-')}`

        Router.push(url.toLowerCase());
      }

      // if locations.length === 1 then go to [state]
      if (filters.locations.length === 1) {
        // const url = categoryParam.length > 0 ?`/for-sale/${category.text.replace(' ', '-')}${categoryParam}` : `/for-sale/${props.range.replace(' ', '-')}`
        const url = categoryParam.length > 0 ? 
          `/for-sale/${props.range.replace(' ', '-')}/${filters.locations[0].replace(' ', '-')}${categoryParam}`
          :
          `/for-sale/${category.text.replace(' ', '-')}/${filters.locations[0].replace(' ', '-')}`
        Router.push(url.toLowerCase());
      }

      // if locations.length === 2 then go to [state]/[region]

      if (filters.locations.length === 2) {
        const url = categoryParam.length > 0 ?
          `/for-sale/${props.range.replace(' ', '-')}/${filters.locations[0].replace(' ', '-')}/${filters.locations[1].replace(' ', '-')}${categoryParam}`
          :
          `/for-sale/${category.text.replace(' ', '-')}/${filters.locations[0].replace(' ', '-')}/${filters.locations[1].replace(' ', '-')}`

        Router.push(url.toLowerCase());
      }
    }

    setStockFilterData(filters);

    console.log('getStockFilterData', {allStock, filters})

    // || get(filters, 'brands.vals[0].checked', false) === true 
    const filteredStock = allStock ? allStock.filter((item) => {
      // brands
      if(findIndex(get(filters, 'brands', []), {value: item.brand, checked: true}) !== -1 ) {
        return item;
      }
    })
    .filter((item) => {
      // categories
      const allActive = get(filters, 'categories', []).find(item => item.value === 'all' && item.checked);
      if(allActive || (item.category && findIndex(get(filters, 'categories', []), {value: item.category.toLowerCase(), checked: true}) !== -1)) {
        return item;
      }
    })
    .filter((item) => {
      // models
      if(findIndex(get(filters, 'models', []), {value: item.name, checked: true}) !== -1) {
        return item;
      }
    })
    .filter((item) => {
      // types
      if(findIndex(get(filters, 'types', []), {value: item.type, checked: true}) !== -1) {
        return item;
      }
    })
    .filter((item)=> {
      // year
      if(
        between(parseInt(get(item, 'year', 0)), parseInt(get(filters, 'year.val[0]', 0)), parseInt(get(filters, 'year.val[1]', 2050)))
        || get(item, 'year', '').length === 0
      ) {
        return item;
      }
    })
    .filter((item)=> {
      // price min
      if(
        between(get(item, 'price', 0), get(filters, 'price.val[0]'), get(filters, 'price.val[1]'))
        // || get(item, 'price', 0) === 0
      ) {
        return item;
      }
    }) 
    : null

    sortItems(filteredStock);
  }

  const handlePaginationChange = (event, value, scroll) => {
    setPage(value);
    setStart(value === 1 ? 0 : (value - 1) * numberPerPage);
    setEnd(paginationLength === value ? categoryStock.length : value * numberPerPage);

    if (scroll !== false) {
      const { top } = containerRef.current.getBoundingClientRect();
      const position = top + window.pageYOffset
      position ? window.scrollTo({
        top: position,
        behavior: 'smooth'
      }) : containerRef.current.scrollIntoView({ behavior: 'smooth'});
    }
  }

  useEffect(() => {
    setDefaultPageTitle(document.title);

    const footer = document.getElementById('main-footer')
    const navHeight = window.innerWidth <= theme.props.mobileNavDownPx ? 0 : 80;
    const footerHeight = footer.clientHeight;
    const windowHeight = window.innerHeight;
    const minHeight = windowHeight - navHeight - footerHeight;

    setLoaderHeight(`${minHeight}px`);

    const getData = async () => {
      await axios({
        method: 'GET',
        url: 'https://www.jayco.com.au/feeds/dealer-stock'
      })
      .then((response) => {
        console.log('response', response)
        setApiData(response.data);
      })
      .catch((error) => {
        console.log('Request error: ', error);
        //setApiData(testData);
      });

      await axios({
        method: 'GET',
        // url: `${window.location.hostname === 'localhost' ? `/data/test-stock-pages-postcodes.json` : `/data/stock-pages-postcodes.json`}`
        url: `/data/stock-pages-postcodes.json`
        // url: 'https://z65d722a-sb-assets-t441d948-sp.s3.amazonaws.com/wp-rest-api-json/stock-pages-postcodes/data.json'
      })
      .then((response) => {
        setPostcodeData(response.data);
        setJsonLoading(false);
        const regionState = response.data.filter(
          item => {
            return (item.state.toLowerCase() === props.state.toLowerCase() && item.region.length > 0 && (!props.region || (item.region.toLowerCase() !== props.region.toLowerCase())))
          }
        ).map((item) => {
          const category = filters.categories.find(item => item.checked);
          const link = `/for-sale/${props.range.replace(' ', '-')}/${props.state.toLowerCase()}${item.region ? `/${item.region.replace(' ', '-')}` : ''}${category && category.text ? `?category=${category.text.replace(' ', '-')}`:'' }`
          return {
            ...item,
            link: link
          }
        });
        setRegions(regionState);
      })
      .catch((error) => {
        console.log('Request error: ', error);
        setJsonLoading(false);
        //setApiData(testData);
      });
      setLoaderHeight('auto');
      setJsonLoading(false);
    }

    getData()
    
  
  },[])

  useEffect(() => {

    if (!apiData || !postcodeData) {
      return
    }

    const dealers = apiData.dealers.filter(dealer => {
      if (props.state && !props.region) {
        return dealer.state.toLowerCase() === props.state.toLowerCase() ? true : false
      } else {
        const region = props.region ? postcodeData.find(i => i.region.toLowerCase() === props.region.split('-').join(' ').toLowerCase()) : null
        if (region) {
          const withinPostcode = dealer.postcodes.find(item => {
            return region.postcodes.indexOf(item) !== -1
          })
          return withinPostcode ? true : false
        } else {
          return true
        }
      }
    })

    console.log('getStockFilterData region category', props, postcodeData)

    const stock = dealers.flatMap(item => item.stock.map(stockItem => {
      return {
        ...stockItem,
        dealerId: item.id,
        dealerName: item.name,
        dealerAddress: {
          addressLine1: item.addressLine1,
          addressLine2: item.addressLine2,
          postcode: item.postcode,
          state: item.state
        }
      }
    }));

    const refactoredStock = refactorUbsData(stock);

    const categoryStock = refactoredStock.filter(item => {
      return (item.variant && (item.variant.toLowerCase() === rangeCategory.toLowerCase())) || rangeCategory === 'all'
    })

    console.log('getStockFilterData', refactoredStock, rangeCategory)

    setAllStock(refactoredStock);
    setCategoryStock(categoryStock);

    const filterData = getStockFilterData();

    setStockFilterData(filterData);
    // updateFilters(filterData);

  }, [props.range, props.state, props.region, apiData, props.router.asPath, postcodeData]);

  useEffect(() => {
    sortItems();
  }, [sortByVal])

  useEffect(() => {
    if (!allStock || allStock.length === 0) {
      return;
    }
    const filterData = getStockFilterData();

    setStockFilterData(filterData);
    // updateFilters(filterData);

  }, [allStock, props.range, props.state, props.region]);

  useEffect(() => {
    handlePaginationChange(null, 1, false);
  }, [stockItems])

  const setCanonical = () => {
    const pageCanonical = document.querySelectorAll('link[rel="canonical"]');
    pageCanonical && window.staticly && pageCanonical[0] && pageCanonical[0].setAttribute("href", 'https://www.' + window.staticly.dealerData.website + window.location.pathname + window.location.search);
  }

  const handleRouteChange = (url, title) => {
    dlPush({
      event: 'pageview',
      appHost: window.location.host,
      appPagepath: url,
      appPagetitle: title || document.title,
      appUrl: window.location.origin + (window.location.pathname !== '/' ? window.location.pathname : '')
    });
    setCanonical();
  }

  const setModelTitle = (data, id, get) => {
    const stock = data ? data : allStock;
    const _id = id ? id : activeModel
    const activeModelData = stock.find(item => (item.id === _id));

    console.log('setModelTitle', data);

    if (!activeModelData) {
      return
    }

    const title = `${activeModelData.make} ${activeModelData.name} | Jayco Australia`;

    document.title = title

    if (get) {
      return title
    }

  }

  const setModels = (data) => {
    if (data.state.model) {
      
      setActiveModelId(data.state.model);
      setModelTitle();
    } else {
      setActiveModelId(null);
      document.title = defaultPageTitle;
    }
  };

  const handleStockCardClick = (e, id) => {
    e && e.preventDefault();
  
    if (id) {
      window.history.pushState({
        model: id
      }, undefined, `${window.location.pathname}?model=${id}`);
      const title = setModelTitle(null, id, true);
      handleRouteChange(`${window.location.pathname}?model=${id}`, title)
    } else {
      window.history.pushState({
      }, undefined, `${window.location.pathname}`);
      document.title = defaultPageTitle;
      handleRouteChange(`${window.location.pathname}`, defaultPageTitle);
    }

    window.scrollTo(0,0);
    setActiveModelId(id);
  }

  useEffect(() => {
    if (activeModelId && allStock) {
      // setDefaultPageTitle(document.title)
      const getData = async (modelId) => {

          setLoading(true);
          
          const GET_UBS_DATA = gql`
            query GetUBSStock {
              getUBSStock(id: "${modelId}") {
                accessoryCodeList
                accessoryDescList
                askingPrice
                body
                branchId
                buildDate
                class
                colour
                complianceDate
                createdAt
                cylinders
                driveAwayPrice
                fuelType
                gearbox
                id
                make
                model
                odometer
                redbookCode
                regoExpiryDate
                regoNumber
                regoState
                seats
                series
                stockNumber
                tare
                trans
                trimColour
                type
                updatedAt
                variant
                vehicleDescription
                images
                vin
              }
            }
          `

          const result = await jaycoClient.query({
            query: GET_UBS_DATA
          }) || {};

          const stock = get(result, 'data.getUBSStock', null)
          const data = stock ? refactorUbsData([stock]) : null

          if (data) {

            const dealerData = allStock ? allStock.find(item => {
              return item.id === activeModelId
            }) : {}

            setActiveModel({
              ...dealerData,
              ...data[0],
            })
          }

          // setError(null);
          setLoading(false);

          if (activeModelParam){
            // setModelTitle(data);
          } 
      }
      getData(activeModelId);
    } else {
      setActiveModel(null);
    }

  },[activeModelId, allStock])

  useEffect(() => {
    setCanonical();
    window.addEventListener('popstate', setModels);
    return () => {
      window.removeEventListener('popstate', setModels);
    }
  }, [])

  useEffect(() => {
    const getPostcodes = () => {
      //setPostcodeLoading(true);
      axios.get('/data/postcodes.json', {})
      .then(function ( response) {
        // handle success
        const lsPostcodes = {
          date: Date.now(),
          data: response.data
        }
        setPostcodes(lsPostcodes.data);
        localStorage.setItem('postcodes', JSON.stringify(lsPostcodes))
        //setPostcodeLoading(false);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        //setPostcodeLoading(false);
      })
      .then(function () {
        // always executed
        //setPostcodeLoading(false);
      });
    }

    const getDealerSuburbs = () => {
      axios.get('/json/dealers.json', {})
      .then(function ( response) {
        // handle success
        setDealerSuburbs(response.data);
        //setPostcodeLoading(false);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        //setPostcodeLoading(false);
      })
      .then(function () {
        // always executed
        //setPostcodeLoading(false);
      });
     
    }

    if (localStorage && localStorage.getItem('postcodes')) {
      const lsPostcodes = JSON.parse(localStorage.getItem('postcodes'));
      if (lsPostcodes.data && lsPostcodes.date > latestTimestamp) {
        setPostcodes(lsPostcodes.data);
      } else {
        getPostcodes();
      }
    } else {
      getPostcodes();
    }

    getDealerSuburbs();
  }, [])  

  const handleLocationSubmit = (val, type) => {

    openModal(false);

    let stateLocation = null

    if (type === 'state') {
      stateLocation = {
        state: val.value
      }
    }

    const closest = type !== 'postcode' ? getClosestCoordinate(val, postcodes) : null; // get current location
    const postcode = type === 'postcode' ? val.postcode : get(closest, 'item.postcode', null); // postcode text input

    if (postcode && postcodeData) {

      const locations = postcodeData.filter(item => {
        return item.postcodes.find(locationPostcode => locationPostcode.toString() === postcode.toString())
      })

      const location = type === 'state' ? stateLocation : locations.length === 1 ? locations[0] : locations.find(item => {
        return item.region.length > 0;
      })

      const category = filters.categories.find(item => item.checked);

      if (location) {

        if (category && category.text && props.categories && props.categories.indexOf(category.text.toLowerCase().replace(' ', '-')) === -1) {
          // static page doesn't exist so use query param instead.
          const url = `/for-sale/${props.range.replace(' ', '-')}/${location.state}${location.region ? `/${location.region.replace(' ', '-')}` : ''}?category=${category.text.replace(' ', '-')}`
          Router.push(url);
          console.log('redirect to: 1 ', url);
        } else {
          const url = `/for-sale/${props.range.replace(' ', '-')}/${location.state}${location.region ? `/${location.region.replace(' ', '-')}` : ''}`
          process.env.NODE_ENV === 'development' ?
            Router.push(url) // window.location.href = url
          :
          Router.push(url);
          console.log('redirect to: 2 ', url);
        }
        setLocationError(null);
      } else {
        setLocationError('No location found.');
      }
    }
  }

  const toTitleCase = (phrase) => {
    return phrase
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Filter Start

  const getActiveModels = (cats, reset) => {
    let models = [];
    stockFilterData.brands.forEach(item => {
      const isChecked = cats.find(cat => (cat.value === item.value) && cat.checked === true)
      if (item.models && isChecked) {
        item.models.forEach(model => {
          const modStateCheckedIndex = findIndex(get(filters, 'models', []), {value: model.value});
          const modIsChecked = modStateCheckedIndex !== -1 ? filters.models[modStateCheckedIndex].checked : true;
          models.push({
            ...model,
            brand: item.value,
            checked: reset ? true : modIsChecked
          })
        })
      }
    })
    return models
  }

  const handleFilterChange = (accordion, type, event, value) => {

    const val = event ? event.target.checked : null;

    console.log('handle filter change', {accordion, type, event, value});

    const newState = (type === 'all' && val) ? produce(filters, draftState => {

      const newVal = filters[accordion].map(item => {
        return {
          ...item,
          checked: true
        }
      })
      draftState[accordion] = Object.values({
        ...draftState[accordion],
        ...newVal
      })
    }) 
    : produce(filters, draftState => {
      
      var newVal

      if (accordion === 'locations') {
        if (type === 0) { // type = index in this case
          newVal= draftState[accordion] = [];
        } else {
          newVal= delete draftState[accordion][type]
        }
      } else {
        if (!value) {
          newVal = draftState[accordion].find(item => {
            if (item.value === type) {
              item.checked = val
            }
          })
        }
      }

      if (accordion === 'price' || accordion === 'year' && value) {
        draftState[accordion] = {
          ...draftState[accordion],
          val: value
        }
      } else if (accordion === 'models') {
        const val = event.target.checked;
        const newState = produce(filters, draftState => {
          const modelIndex = findIndex(filters.models, {value: type});
          draftState.models[modelIndex].checked = val
        });
        draftState[accordion] = newState.models
      } else if (accordion === 'categories') {
        const vals = filters[accordion].map(item => {
          return {
            ...item,
            checked: item.value === type ? true : false
          }
        })
        draftState[accordion] = Object.values({
          ...vals,
        })
      } else {
        draftState[accordion] = Object.values({
          ...draftState[accordion],
          ...newVal
        })
      }
      const allIndex = findIndex(filters[accordion], {'value': 'all'})
      if (allIndex !== -1 && draftState[accordion][allIndex]) {
        draftState[accordion][allIndex].checked = false
      }
    })


    
    if (accordion === 'brands') {
      const newModelArr = getActiveModels(newState.brands);
      handleUpdate({
        ...newState,
        models: newModelArr
      })
    } else {
      handleUpdate(newState)
    }
  }

  const setFilters = () => {
    
    // categories
    const categories = stockFilterData.categories.map(item => {
      return {
        ...item,
        checked: rangeCategory === item.text.toLowerCase() ? true : false
      }
    })

    let models = stockFilterData.models;

    const qsData = qs.parse(window.location.search.replace('?',''));

    if (qsData.search && qsData.search.series && qsData.search.series !== 'all') {
      console.log('set filters... do something here...', qsData);
        // models/series:
        models = stockFilterData.models.map(item => {
          return {
            ...item,
            checked: qsData.search.series.toLowerCase() === item.text.toLowerCase() ? true : false
          }
        })

    }

    if (qsData.search && qsData.search.sort) {
      setSortByVal(qsData.search.sort);
    }


    const filterProps = {
      key: Date.now(),
      ...stockFilterData,
      types: stockFilterData.types,
      categories,
      brands: stockFilterData.brands,
      models: models,
      locations: stockFilterData.locations
    }

    console.log('set filters...', filterProps);

    updateFilters(filterProps);
  }



  useEffect(() => {
    if (stockFilterData) {
      setFilters();
    }
  },[stockFilterData, props.range, props.state, props.region, props.router.query.category])

  // Filter End

  const handleClear = (e) => {

    const filterData = getStockFilterData();
    
    const defaultState = props.range === 'all' ? {
      ...filterData,
      categories: filterData.categories.map(item => {
        if(item.value === 'all') {
          return {
            ...item,
            checked: true
          }
        }
        return item
      })
    } : filterData
    handleUpdate(defaultState);
  }

  const handleClearItem = (item) => {

    const newState = {
      ...filters,
      [item]: filters[item].map(item => {
        return {
          ...item,
          checked: false
        }
      })
    }

    // console.log('handleClearItem:', {item, newState, filters})

    handleUpdate(newState);
  }

  const handleFilterRemove = (type) => {
    console.log('router push...', type);
    if (type === 'state') {
      const url = `/for-sale/${props.range.replace(' ', '-')}`;
      console.log('go to', url);
      Router.push(url.toLowerCase());
    }

    if (type === 'region') {
      const url = `/for-sale/${props.range.replace(' ', '-')}/${props.state}`;
      console.log('go to', url);
      Router.push(url.toLowerCase());
    }

    if (type === 'range') {
      const url = `/for-sale/all${props.state ? `/${props.state}` : ''}${props.region ? `/${props.region}`: ''}`;
      console.log('go to', url);
      Router.push(url.toLowerCase());
    }
  }

  const handleBcClick = (e, link) => {
    console.log('handleBcClick', link, window.location.pathname);
    if (link.href === window.location.pathname) {
      handleStockCardClick(e, null);
    }
  }

  const containerRef = useRef();
  // Pagination
  const paginationLength = stockItems ? Math.ceil(stockItems.length / numberPerPage) : 0;
  const classes = useStyles();


  const stateName = props.state ? getStateName(props.state.toLowerCase()) : null;

  console.log('fs', props)

  return (
    <>
      {(loading || jsonLoading) &&
        <LoaderContainer minHeight={loaderHeight}>
          <Grid container className={'hasPadding'} direction={'row'} wrap="wrap">
            <Grid item xs={12}>
              <Box px={2}>
                <Loader />
              </Box>
            </Grid>
          </Grid>
        </LoaderContainer>
      }
      <Wrapper hide={loading || jsonLoading ? 1 : 0}>
        {(activeModel) ?
          <>
              <Container pt={0}>
                <StockItem
                  dealerSuburbs={dealerSuburbs}
                  key={activeModelId}
                  model={activeModelId}
                  allStock={categoryStock}
                  onStockCardClick={handleStockCardClick}
                  data={activeModel}
                  breadcrumbs={props.breadcrumbs}
                  onBreadcrumbClick={() => handleBcClick(undefined, {href: window.location.pathname})}
                  calculatorModal={props.calculatorModal}
                />
            </Container>
          </>
        :
        <Container ref={containerRef} greyBg={true}>
          {(!loading && !jsonLoading) &&
          <Modal
            isOpen={modal}
            onClose={() => openModal(false)}
            overlayClassname={classes.modalOverlay}
            innerClassname={classes.modalInner}
            closeClassname={classes.modalClose}
          >
            <GetLocationContainer>
              <GetLocation 
                onSubmit={handleLocationSubmit}
                locationButton={false}
                stateDropdown={true}
                // postcode={postcodeQuery ? postcodeQuery.toString() : ''}
              />
              {locationError &&
                <GetLocationError>
                  <Text variant="body2" element="p" align="center">{locationError}</Text>
                </GetLocationError>
              }
            </GetLocationContainer>
          </Modal>
          }
          {((!loading && !jsonLoading) || !process.browser) &&
            <>
            {props.breadcrumbs && 
                <Topo>
                  <LeftPadding>
                    <Grid container className={'hasPadding'} direction={'row'} wrap="wrap">
                      <Grid item xs={12}>
                        <Box px={2}>
                          <BreadcrumbsContainer>
                            <Breadcrumbs items={props.breadcrumbs}/>
                          </BreadcrumbsContainer>
                        </Box>
                      </Grid>
                    </Grid>
                  </LeftPadding>
                </Topo>
            }
            {/* <Grid container className={'hasPadding'} direction={'row'} wrap="wrap">
              <Grid item xs={12}>

                <TitleContainer>
                  <Text variant="h2" element="h1" colour="charcoal" align="center" uppercase>{props.title.replace('[range]', rangeCategory)}</Text>
                </TitleContainer>
              </Grid>
            </Grid> */}
            </>
          }
          {(!loading && !jsonLoading) &&
            <LeftPadding>
              <Grid container className={'hasPadding'} direction={'row'} wrap="wrap">
                {isWidthUp('lg', props.width) &&
                  <Grid item xs={12} lg={3}>
                    <Box px={2}>
                      {/* {props.breadcrumbs && 
                        <BreadcrumbsContainer>
                          <Breadcrumbs items={props.breadcrumbs}/>
                        </BreadcrumbsContainer>
                      } */}
                      <StockFilter
                        id={stockFilterData && stockFilterData.key}
                        filters={filters}
                        regions={regions}
                        onUpdate={handleUpdate}
                        onModal={(val) => openModal(val)}
                        onFilterChange={handleFilterChange}
                        categoryType="radio"
                        onClear={handleClear}
                        state={props.state}
                        onClearItem={handleClearItem}
                        category={get(props, 'router.query.range', 'all')}
                      />
                    </Box>
                  </Grid>
                }
                {(!isWidthUp('lg', props.width)) &&
                  <>
                    <ThemeProvider theme={customTheme}>
                      <SwipeableDrawer
                        anchor="right"
                        open={drawer}
                        onClose={() => setDrawer(false)}
                        onOpen={() => setDrawer(true)}
                      >
                        <ThemeProvider theme={theme}>
                          <FilterContainer>
                            <CloseContainer>
                              <ButtonBase onClick={() => setDrawer(false)}>
                                <ReactSVG src={close} />
                              </ButtonBase>
                            </CloseContainer>
                            <Filters>
                              <Box px={2}>
                                <StockFilter
                                  id={stockFilterData && stockFilterData.key}
                                  filters={filters}
                                  regions={regions}
                                  onUpdate={handleUpdate}
                                  onModal={(val) => openModal(val)}
                                  onFilterChange={handleFilterChange}
                                  categoryType="radio"
                                  onClear={handleClear}
                                  state={props.state}
                                  onClearItem={handleClearItem}
                                  category={get(props, 'router.query.range', 'all')}
                                />
                                <Buttons>
                                  <Cta inline onClick={() => setDrawer(false)} >Search</Cta>
                                  <Cta inline outline onClick={() => setDrawer(false)} >Cancel</Cta>
                                </Buttons>
                              </Box>
                            </Filters>
                          </FilterContainer>
                        </ThemeProvider>
                      </SwipeableDrawer>
                    </ThemeProvider>
                  </>
                }
                <Grid item xs={12} lg={9}>
                  <Box px={isWidthUp('lg', props.width) ? 2 : 0}>
                    <GreyWrapper>
                      {/* <GreyTop /> */}
                      <GreyBg>
                        <Box px={isWidthUp('md', props.width) ? 4 : 2}>

                          <TitleContainer>
                            <Text variant="h3" weight="800" element="h1" colour="charcoal" uppercase>{props.title.replace('[range]', rangeCategory)}</Text>
                          </TitleContainer>

                          {regions.length > 0 &&
                            <Locations>
                              <Text variant="body1" align="left" colour={'black'}>
                                  Browse: 
                                  {regions.map(item => <a key={item.region} href={item.link}>{item.region}</a>)}
                              </Text>
                            </Locations>
                          }

                          {(!isWidthUp('lg', props.width)) &&
                            <Grid item xs={12}>
                              <Box px={2}>
                                <FilterBtn outline inline onClick={() => setDrawer(true)}>
                                <ReactSVG src={filter} />
                                <span>Filter Range</span></FilterBtn>
                              </Box>
                            </Grid>
                          }
                          
                          <ShowingText variant="body1" align="left" colour={'black'}> Showing {stockItems ? stockItems.slice(start,end).length : 0} of {stockItems ? stockItems.length : 0}</ShowingText>

                          <Display>
                            <DisplayItems>
                              {/* <Text variant="h6" align="left" colour="charcoal">{stockItems.length} {toTitleCase(rangeCategory)} in {props.region && ` ${toTitleCase(props.region)},`}{(!props.region && props.state) ? ` ${props.state.toUpperCase()},` : ''} Australia </Text> */}
                              {/* <Text variant="body2">DEALER</Text> */}
                              
                              {props.state &&
                                <FilterItem title={stateName ? stateName : props.state} onClick={() => handleFilterRemove('state')} />
                              }

                              {props.region &&
                                <FilterItem title={props.region.toLowerCase().split('-').join(' ')} onClick={() => handleFilterRemove('region')} />
                              }

                              {(props.range && props.range !== 'all') &&
                                <FilterItem title={props.range.toLowerCase()} onClick={() => handleFilterRemove('range')} />
                              }

                              {(props.range && props.range !== 'all') &&
                                <Link href="/for-sale/all">
                                  <a onClick={handleClear}>Clear all</a>
                                </Link>
                              }

                            </DisplayItems>
                            <DisplayDropdown>
                              <Dropdown
                                options={[{
                                    value: 'name',
                                    text: 'Product name (A-Z)'
                                  },{
                                    value: 'low',
                                    text: 'Sort by price (low to high)'
                                  },{
                                    value: 'high',
                                    text: 'Sort by price (high to low)'
                                  }
                                ]} // because there's duplicate 'values'
                                value={sortByVal}
                                onChange={(e) => setSortByVal(e)}
                              />
                            </DisplayDropdown>
                          </Display>
                        </Box>
                        <Box px={isWidthUp('lg', props.width) ? 2 : 1} py={4}>
                          {stockItems.length === 0 &&
                            <Grid container direction={'row'}>
                              <Grid item xs={12}>
                                <Box px={2}>
                                  <Text variant="body1" colour="black">No stock. Please refine your search.</Text>
                                </Box>
                              </Grid>
                            </Grid>
                          }
                          <Grid container direction={'row'}>

                            {stockItems && stockItems.slice(start,end).map(item => (
                              <Grid item xs={12} sm={6} lg={4} key={item.id}>
                                <CaravanCardWrapper px={isWidthUp('lg', props.width) ? 2 : 1}>
                                  <CaravanCardContainer>
                                    <StockCard
                                      {...item}
                                      onClick={handleStockCardClick}
                                      price={item.price ? `$${toPrice(item.price)}` : null}
                                    />
                                  </CaravanCardContainer>
                                </CaravanCardWrapper>
                              </Grid>
                            ))}

                            {paginationLength > 1 &&
                              <Grid item xs={12}>
                                <PaginationContainer>
                                  <Pagination
                                    page={page}
                                    onChange={handlePaginationChange}
                                    count={paginationLength}
                                  />
                                </PaginationContainer>
                              </Grid>
                            }
                          </Grid>
                        </Box>
                      </GreyBg>
                    </GreyWrapper>
                  </Box>
                </Grid>

              </Grid>
            </LeftPadding>
          }
                    
        </Container>

        }

        {props.contentBuilder && 
          <ContentBuilder
            data={props.contentBuilder}
          />
        }
      </Wrapper>  
    </>
  )
}

export default withWidth(ForSale)

